import { post, get } from '../index'

export default {
  getGroupGoodsList (querys) {
    return get('/admin/admin/file/listFile', querys)
  },
  delGroups (querys) {
    return post('/admin/admin/file/delAllGroup', querys)
  },
  // 修改分组
  updateGroup (querys) {
    return post('/admin/admin/file/updateGroup', querys)
  },
  // 删除单个分组
  delGroup (querys) {
    return post('/admin/admin/file/delGroup', querys)
  },
  // 怎增分组
  addGroup (querys) {
    return post('/admin/admin/file/createGroup', querys)
  },
  // 获取上传商品分组列表
  getGroupsList () {
    return get('/admin/admin/file/listGroup')
  },
  // 获取商品分类列表
  getMallsGoodsClassify () {
    return post('/shop/admin/AdminShopType/cateList')
  },
  // 商品分类列表上下架设置
  cateStatusUpdate (querys) {
    return post('/shop/admin/AdminShopType/cateStatusUpdate', querys)
  },
  // 添加商品分类
  addClassify (querys) {
    return post('/shop/admin/AdminShopType/cateAdd', querys)
  },
  // 获取分类信息和修改分类信息
  getOrModifyClassifyInfo (querys) {
    return post('/shop/admin/AdminShopType/cateUpdate', querys)
  },
  // 获取一级分类下拉框中值
  getSelectClassifyOptions () {
    return post('/shop/admin/AdminShopType/cateTop')
  },
  // 删除商品分类列表的值
  delGoodsClassify (querys) {
    return post('/shop/admin/AdminShopType/cateDelete', querys)
  },
  // 获取商品列表
  getGoodsList (querys) {
    return post('/shop/admin/AdminShopGoods/goodsList', querys)
  },
  // 上下架商品（status：1,0）和删除商品（status：-1）
  upperAndDelGoods (querys) {
    return post('/shop/admin/AdminShopGoods/goodsStatusUpdate', querys)
  },
  // 获取商品规格列表
  addSpecsList (querys) {
    return post('/shop/admin/AdminShopGoods/goodsSpeList', querys)
  },
  // 添加商品信息
  addGoodsInfo (querys) {
    return post('/shop/admin/AdminShopGoods/goodsAdd', querys)
  },
  // 编辑商品信息
  editGoodsInfo (querys) {
    return post('/shop/admin/AdminShopGoods/goodsUpdate', querys)
  },
  // 删除规格名和规格值
  delSpecs (querys) {
    return post('/shop/admin/AdminShopGoods/speDel', querys)
  },
  // 添加规格名
  addSpecs (querys) {
    return post('/shop/admin/AdminShopGoods/goodsSpeAdd', querys)
  },
  // 保存规格列表
  submitSpecsList (querys) {
    return post('/shop/admin/AdminShopGoods/goodsSpeAddPrice', querys)
  },
  // 获取商品列表和商品添加中的下拉菜单中的值(部门，分类)(商品编辑页面也会用)
  GoodsListSelect () {
    return post('/shop/admin/AdminShopGoods/companyAndCate')
  },
  // 清除商品列表中的商品二维码
  clearGoodsQrCode () {
    return post('/shop/admin/AdminShopGoods/')
  },
  // 获取订单列表
  getGoodsOrderList (querys) {
    return post('/shop/admin/AdminShopOrder/orderList', querys)
  },
  // 导出订单
  exportOrder (querys) {
    return get('/shop/admin/AdminExcel/returnUrl', querys)
  },
  // 获取订单详情
  getOrderInfo (querys) {
    return post('/shop/admin/AdminShopOrder/orderInfo', querys)
  },
  // 获取订单设置信息回显
  orderSettingInfo () {
    return post('/shop/admin/AdminShopSetting/configInfo')
  },
  // 订单保存设置信息
  orderSetting (querys) {
    return post('/shop/admin/AdminShopSetting/configUpdate', querys)
  },
  // 支付设置、回显
  paymentSetting (querys) {
    return post('/shop/admin/AdminShopSetting/configPay', querys)
  },
  // 获取福包列表
  getRedPackitList (querys) {
    return post('/shop/admin/AdminCoupon/couponList', querys)
  },
  // 修改福包状态，信息回显
  updateRedPackitStatus (querys) {
    return post('/shop/admin/AdminCoupon/couponUpdate', querys)
  },
  // 添加福包信息
  addRedPackitInfo (querys) {
    return post('/shop/admin/AdminCoupon/couponsAdd', querys)
  },
  // 获取福包编辑页面下拉选项值
  getRedPakitOptions () {
    return post('/shop/admin/AdminCoupon/getGoodsAndCate')
  },
  // 商品的拼团列表
  getGoodsAssembleList (querys) {
    return post('/shop/admin/AdminShopCollage/goodsCollageList', querys)
  },
  // 拼团记录列表
  getAssembleRecordList (querys) {
    return post('/shop/admin/AdminShopCollage/collageList', querys)
  },
  // 编辑拼团和删除拼团
  editOrDelGoodsAssemble (querys) {
    return post('/shop/admin/AdminShopCollage/goodsCollageUpdate', querys)
  },
  // 添加拼团信息
  addAssembleInfo (querys) {
    return post('/shop/admin/AdminShopCollage/goodsCollageAdd', querys)
  },
  // 获取编辑拼团页面的下拉框的值
  getAssembleOptions (querys) {
    return post('/shop/admin/AdminShopCollage/getSpePrice', querys)
  },
  // 退款列表
  refundList (querys) {
    return post('/shop/admin/AdminShopOrderRefund/orderRefundList', querys)
  },
  // 立即退款
  settingRefundInfo (qeurys) {
    return post('/shop/admin/AdminShopOrderRefund/orderRefund', qeurys)
  },
  // 拒绝退款
  cancelRefund (querys) {
    return post('/shop/admin/AdminShopOrderRefund/cancelRefund', querys)
  },
  // 获取分销收益列表数据
  getDistributionProfirList (querys) {
    return get('/shop/admin/AdminSellingProfit/profitList', querys)
  },
  // 获取佣金信息列表
  getDistributionCommissionList (querys) {
    return get('/shop/admin/AdminSellingWater/waterList', querys)
  },
  // 获取提现列表
  getCashList (qeurys) {
    return get('/shop/admin/AdminSellingCash/cashList', qeurys)
  },
  // 确认到账
  confirmOnCash (querys) {
    return post('/shop/admin/AdminSellingCash/onCash', querys)
  },
  // 在线转账
  confirmWxCash (querys) {
    return post('/shop/admin/AdminSellingCash/wxCash', querys)
  },
  // 分销表单的数据回显与编辑
  getEditDistributionSetting (querys) {
    return post('/shop/admin/AdminSellingProfit/retailSetting', querys)
  },
  // 获取分销关系列表
  getDistributionRelationList (querys) {
    return get('/shop/admin/AdminSellingProfit/relationList', querys)
  },
  // 获取关系列表查找
  getDistributionRelationLookupList (querys) {
    return get('/shop/admin/AdminSellingProfit/relationSelect', querys)
  },
  // 获取商城轮播图
  getMallsBanners (querys) {
    return post('/shop/admin/AdminShopBanner/bannerList', querys)
  },
  // 添加商城轮播图
  addMallsBanner (querys) {
    return post('/shop/admin/AdminShopBanner/bannerAdd', querys)
  },
  // 删除商城轮播图
  delMallsBanner (querys) {
    return post('/shop/admin/AdminShopBanner/bannerDel', querys)
  },
  // 编辑、上下架、回显商城轮播图
  editUpdateMallsBanner (querys) {
    return post('/shop/admin/AdminShopBanner/bannerUpdate', querys)
  },
  // 获取公司分类（下拉菜单）
  getMallsCompanyOptions (querys) {
    return post('/shop/admin/AdminShopBanner/getCompany', querys)
  },
  // 订单发货
  orderSettingSendGoods (querys) {
    return post('/shop/admin/AdminShopOrder/orderSend', querys)
  },
  // 订单自提
  orderSettingSelfGoods (querys) {
    return post('/shop/admin/AdminShopOrder/selfOrder', querys)
  },
  // 订单按部门、公司跟新
  getRefreshOrder () {
    return get('/shop/admin/AdminShopOrder/refreshOrder')
  },
  // 下载福包码
  downloadRedPackitCode (querys) {
    return post('/shop/admin/AdminCoupon/couponShareQr', querys)
  },
  // 添加自提点
  storeAdd (querys) {
    return post('/shop/admin/AdminStore/storeAdd', querys)
  },
  // 修改自提点
  storeUpdate (querys) {
    return post('/shop/admin/AdminStore/storeUpdate', querys)
  },
  // 自提点详情
  storeInfo (querys) {
    return post('/shop/admin/AdminStore/storeInfo', querys)
  },
  // 上0 下1 架 删除-1
  storeStatusUpdate (querys) {
    return post('/shop/admin/AdminStore/statusUpdate', querys)
  },
  // 自提点列表
  storeList (querys) {
    return post('/shop/admin/AdminStore/storeList', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/malls.js